import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.DARK_ONYX};
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
`;

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
`;

export const StyledButton = styled(Button)`
  margin-top: auto;
`;

export const StyledLinkBlock = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  padding: 0.25rem;
  text-align: center;
`;

export const StyledFeedLink = styled(Link)`
  display: flex;
  gap: 0.5rem;
  text-decoration: underline;
  color: ${COLORS.BLUE_PRIMARY};
  ${pickThemeFontStyles('12', '16', 'NORMAL')};

  svg {
    path {
      stroke: ${COLORS.BLUE_PRIMARY};
    }
  }
`;
